import {
    getUserFromStorage,
    useRelodeAppUI,
} from "@relode/core";
import { format } from "date-fns";
import * as React from "react";

import {
    Page,
    PageContent,
    PageHeader,
    PageHeaderTitle,
} from "../";

export const DashboardPage = (props: {
    children?: React.ReactNode;
    dashboardSyncDate?: Date;
}) => {
    const { ui } = useRelodeAppUI();
    const { children, dashboardSyncDate } = props;

    const [greeting, setGreeting] = React.useState<string>("");

    // set up initial greeting
    React.useEffect(() => {
        calculateGreeting();
        ui.actions.setPageTitle("dashboard");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const calculateGreeting = () => {
        const currentUser = getUserFromStorage();
        const firstName =
            currentUser && currentUser.firstName
                ? currentUser!.firstName.toLowerCase()
                : "you";

        const hours = new Date().getHours();
        let calcGreeting = `good morning, ${firstName}!`;
        if (hours >= 12 && hours < 17) {
            calcGreeting = `good afternoon, ${firstName}`;
        } else if (hours >= 17 && hours < 22) {
            calcGreeting = `good evening, ${firstName}`;
        } else if (hours >= 22 && hours < 24) {
            calcGreeting = `late night, ${firstName}?`;
        } else if (hours >= 0 && hours < 4) {
            calcGreeting = `sleep walking, ${firstName}?`;
        } else if (hours >= 4 && hours < 6) {
            calcGreeting = `early start, ${firstName}?`;
        }

        setGreeting(calcGreeting);
    };

    return (
        <Page pageType="cool" data-cy="dashboard-page">
            <PageHeader>
                <PageHeaderTitle
                    title={greeting}
                    subTitle={`last sync on ${format(
                        dashboardSyncDate,
                        "P p"
                    )}`}
                />
            </PageHeader>
            <PageContent>{children}</PageContent>
        </Page>
    );
};
